import Vue from "vue";
import VueRouter from "vue-router";

//页面
import home from "./pages/home";

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  if(typeof(location)=="string"){
    var Separator = "&";
    if(location.indexOf('?')==-1) { Separator='?'; }
    location = location + Separator + "random=" + Math.random();
  }
  return routerPush.call(this, location).catch(error=> error)
}



Vue.use(VueRouter);

const routes = [
    {
        path:"/home/:sidetype?",
        component: home,
        meta: {title:'中科趣商会编辑器',keyword:'编辑器',description:'中科趣商会,中科趣商会编辑器'}
    },
    {
        path:"/",
        redirect: "/home/temp"
    }
]

var router =  new VueRouter({
    routes
})
router.beforeEach((to, from, next) => {
  console.log(to, from);
  if (to.query.time&&to.query.new_id){
    next({
      path: to.path,
      query: from.query
    });
  } else {
    next();
  }
})
export default router;